// Lightweight page title used on inner portal pages.
export default function PageHeader({ title, subtitle }) {
  return (
    <div className="px-5 md:px-0 pt-6 pb-2">
      <h1 className="text-xl font-semibold text-glk-dark">{title}</h1>
      {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
    </div>
  );
}
